import { render, staticRenderFns } from "./serviceStatus.vue?vue&type=template&id=1248c515&scoped=true&"
import script from "./serviceStatus.vue?vue&type=script&lang=js&"
export * from "./serviceStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1248c515",
  null
  
)

export default component.exports